// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleApiTokenCreator = {
  id: "api-token-creator",
  mrn: "//iam.api.mondoo.app/roles/api-token-creator",
  title: "API Token Creator",
  allowedActions,
} as const;

export type RoleApiTokenCreator = typeof roleApiTokenCreator;
